import { Routes, Route, Link, NavLink, useSearchParams } from 'react-router-dom'
import { RequestPage } from './pages/request-page'
import { FeedbackPage } from './pages/feedback-page'
import { RequestsPage } from './pages/requests-page'
import { detectLang, t } from './lib/i18n'

export function App() {
  const [params] = useSearchParams()
  const lang = detectLang(params)
  const langSuffix = `?lang=${lang}`

  return (
    <div className="min-h-screen bg-bg text-text">
      <header className="border-b border-border bg-bg-elevated/80 backdrop-blur">
        <div className="container flex h-14 items-center justify-between">
          <Link to={`/request${langSuffix}`} className="flex items-center gap-2 font-semibold">
            <span className="text-primary-text">Claudemy</span>
            <span className="text-text-subtle">/ Forms</span>
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <NavTab to={`/request${langSuffix}`} label={t(lang, 'header.tab.request')} />
            <NavTab to={`/feedback${langSuffix}`} label={t(lang, 'header.tab.feedback')} />
            <NavTab to={`/requests${langSuffix}`} label={t(lang, 'header.tab.community')} />
          </nav>
        </div>
      </header>

      <main className="container py-10">
        <Routes>
          <Route path="/" element={<RequestPage />} />
          <Route path="/request" element={<RequestPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/requests" element={<RequestsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <footer className="border-t border-border py-6 text-center text-sm text-text-subtle">
        <a href="https://claudemy.org" className="hover:text-primary-text">
          ← {lang === 'vi' ? 'Về Claudemy' : 'Back to Claudemy'}
        </a>
      </footer>
    </div>
  )
}

function NavTab({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-2 py-1 rounded-md transition-colors ${
          isActive ? 'text-text font-medium' : 'text-text-muted hover:text-text'
        }`
      }
    >
      {label}
    </NavLink>
  )
}

function NotFound() {
  return (
    <div className="text-center py-20">
      <h1 className="text-2xl font-semibold mb-2">404</h1>
      <p className="text-text-muted">Không tìm thấy trang.</p>
    </div>
  )
}
